import * as types from './mutation-types'

export default {
    [types.SET_SIGNATURE](state, signature) {
        state.signature = signature
    },
    [types.SET_COSIGNER](state, cosigner) {
        state.cosigner = cosigner
    },
    [types.SET_CONTENT](state, content) {
        state.content = content
    },
    [types.SET_TERM](state, term) {
        state.term = term
    },
    [types.SET_TEACHER](state, teacher) {
        state.teacher = teacher
    },
    [types.SET_INSTITUTION](state, institution) {
        state.institution = institution
    },
    [types.SET_LOADING](state, loading) {
        state.loading = loading
    },
    [types.SET_ERROR](state, error) {
        state.error = error
    },
    [types.RESET_STATE](state) {
        state.signature = null
        state.cosigner = null
        state.content = null
        state.term = null
        state.teacher = null
        state.institution = null
        state.loading = false
        state.error = null
    }
}
